import { render, staticRenderFns } from "./NewAberrationContainer.vue?vue&type=template&id=5f95e382"
import script from "./NewAberrationContainer.vue?vue&type=script&lang=ts"
export * from "./NewAberrationContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports